// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    IEnvelopeResendLatestRequest,
    IEnvelopeResendRequest,
    SignatureV1EmailSignatureTemplateCreateEnvelopeResponse,
    SignatureV1EnvelopeResendResponse,
    SignatureV1RecipientViewRequestUrlResponse,
    TCQpSignatureModelEmailSignatureTemplateRequest,
    TCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeSignatureApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param tCQpSignatureModelEmailSignatureTemplateRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async emailSignatureTemplateCreateEnvelope (tCQpSignatureModelEmailSignatureTemplateRequest: TCQpSignatureModelEmailSignatureTemplateRequest, xProgramId?: string): Promise<AxiosResponse<SignatureV1EmailSignatureTemplateCreateEnvelopeResponse>> {
        const _url_ = '/edge/signature/v1/EmailSignatureTemplate/CreateEnvelope';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'tCQpSignatureModelEmailSignatureTemplateRequest' is not null or undefined
        if (tCQpSignatureModelEmailSignatureTemplateRequest === null || tCQpSignatureModelEmailSignatureTemplateRequest === undefined) {
            throw new Error('Required parameter tCQpSignatureModelEmailSignatureTemplateRequest was null or undefined when calling emailSignatureTemplateCreateEnvelope.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCQpSignatureModelEmailSignatureTemplateRequest, "TCQpSignatureModelEmailSignatureTemplateRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SignatureV1EmailSignatureTemplateCreateEnvelopeResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SignatureV1EmailSignatureTemplateCreateEnvelopeResponse");
        }
        return response;
    }
    /**
     * 
     * @param iEnvelopeResendRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async envelopeResend (iEnvelopeResendRequest: IEnvelopeResendRequest, xProgramId?: string): Promise<AxiosResponse<SignatureV1EnvelopeResendResponse>> {
        const _url_ = '/edge/signature/v1/Envelope/Resend';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iEnvelopeResendRequest' is not null or undefined
        if (iEnvelopeResendRequest === null || iEnvelopeResendRequest === undefined) {
            throw new Error('Required parameter iEnvelopeResendRequest was null or undefined when calling envelopeResend.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iEnvelopeResendRequest, "IEnvelopeResendRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SignatureV1EnvelopeResendResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SignatureV1EnvelopeResendResponse");
        }
        return response;
    }
    /**
     * 
     * @param iEnvelopeResendLatestRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async envelopeResendLatest (iEnvelopeResendLatestRequest: IEnvelopeResendLatestRequest, xProgramId?: string): Promise<AxiosResponse<SignatureV1EnvelopeResendResponse>> {
        const _url_ = '/edge/signature/v1/Envelope/ResendLatest';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iEnvelopeResendLatestRequest' is not null or undefined
        if (iEnvelopeResendLatestRequest === null || iEnvelopeResendLatestRequest === undefined) {
            throw new Error('Required parameter iEnvelopeResendLatestRequest was null or undefined when calling envelopeResendLatest.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iEnvelopeResendLatestRequest, "IEnvelopeResendLatestRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SignatureV1EnvelopeResendResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SignatureV1EnvelopeResendResponse");
        }
        return response;
    }
    /**
     * 
     * @param tCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async recipientViewRequestUrl (tCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest: TCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest, xProgramId?: string): Promise<AxiosResponse<SignatureV1RecipientViewRequestUrlResponse>> {
        const _url_ = '/edge/signature/v1/RecipientView/RequestURL';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'tCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest' is not null or undefined
        if (tCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest === null || tCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest === undefined) {
            throw new Error('Required parameter tCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest was null or undefined when calling recipientViewRequestUrl.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest, "TCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SignatureV1RecipientViewRequestUrlResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SignatureV1RecipientViewRequestUrlResponse");
        }
        return response;
    }
}
